// Global variable to keep stream reference when microphone is enabled
let activeMicStream: MediaStream | null = null;

const getDefaultMicStream = async () => {
  if (!activeMicStream) {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    activeMicStream = stream;
  }

  return activeMicStream;
};

const stopMicStream = () => {
  if (activeMicStream) {
    // Stop audio track to tell the browser the microphone is not in use
    activeMicStream.getTracks()[0].stop();
    // Drop the stream because the track is inactive
    activeMicStream = null;
  }
};

export { getDefaultMicStream, stopMicStream };
